import CanvasRain from './src/canvas-rain'

export default CanvasRain;
